import { Lock } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { routeNames } from 'src/modules/core/constants/routeNames'
import { Button, Typography } from 'src/modules/core/components'
import type { RescheduleBlockedProps, RescheduleBlockedView } from './reschedule-blocked.interface'
import classes from './reschedule-blocked.module.scss'

function PolicyBlock({ text }: { text: string | null }) {
  if (!text) return null
  return (
    <div className={classes.policyBlock}>
      <Typography variant="span" className={classes.policyLabel}>
        Cancellation policy
      </Typography>
      <Typography variant="body" className={classes.policyText}>
        {text}
      </Typography>
    </div>
  )
}

function StillComing({ code }: { code: string | null }) {
  const navigate = useNavigate()
  if (!code) return null
  return (
    <div className={classes.stillComing}>
      <Typography variant="body" className={classes.stillComingText}>
        Still planning to come?
      </Typography>
      <Button variant="withBorder" onClick={() => navigate(`${routeNames.confirmation.path}/${code}`)}>
        Confirm appointment
      </Button>
    </div>
  )
}

function AppointmentLine({ view }: { view: RescheduleBlockedView }) {
  return (
    <div className={classes.details}>
      <Typography variant="body" className={classes.businessName}>
        {view.businessName}
      </Typography>
      {view.appointmentLabel && (
        <Typography variant="body" className={classes.appointmentTime}>
          {view.appointmentLabel}
        </Typography>
      )}
    </div>
  )
}

export function RescheduleBlocked({ view }: RescheduleBlockedProps) {
  const business = view.businessName
  return (
    <div className={classes.root} data-testid="reschedule-blocked">
      <div className={classes.lockBadge}>
        <Lock size={22} aria-label="Locked" />
      </div>
      <Typography variant="h1" className={classes.title}>
        Online rescheduling has closed
      </Typography>
      <AppointmentLine view={view} />
      <Typography variant="body" className={classes.bodyText}>
        This appointment is inside {business}&apos;s cancellation window, so it can&apos;t be moved online. To change
        the time, please contact them.
      </Typography>
      {view.cutoffLabel && (
        <Typography variant="body" className={classes.bodyText}>
          The cancellation window closed on <strong>{view.cutoffLabel}</strong>.
        </Typography>
      )}
      <PolicyBlock text={view.policyText} />
      <div className={classes.contactCard}>
        <Typography variant="body" className={classes.contactCardTitle}>
          {business}
        </Typography>
        <Typography variant="body" className={classes.contactCardText}>
          Please use the contact details you have for {business} to change your time.
        </Typography>
      </div>
      <StillComing code={view.confirmationUrlCode} />
    </div>
  )
}
